export const STATUS_TYPE = {
    0: { text: '充值成功', color: 'success' },
    1: { text: '已提交', color: 'info' },
    2: { text: '已取消', color: 'disabled' },
    3: { text: '等待区块确认', color: 'info' },
    '-1': { text: '失败', color: 'danger' },
    4: { text: '已审核', color: '' },
    5: { text: '区块链网络已经发送，等待确认中', color: 'warning' },
    6: { text: '系统异常', color: 'danger' },
    7: { text: '管理员撤销', color: 'disabled' },
    8: { text: '人工复审中', color: 'danger' },
    10: { text: '等待入账', color: 'info' },
};

export const DEPOSIT_STATUS_TYPE = {
    0: { text: '已确认', color: 'success' },
    1: { text: '已提交', color: 'info' },
    2: { text: '已取消', color: 'disabled' },
    3: { text: '确认中', color: 'disabled' },
    '-1': { text: '失败', color: 'danger' },
    4: { text: '已审核', color: '' },
    5: { text: '区块链网络已经发送，等待确认中', color: 'warning' },
    6: { text: '系统异常', color: 'danger' },
    7: { text: '管理员撤销', color: 'disabled' }
};

export const DEPOSIT_STATUS = {
    0: { text: '已确认', color: 'success' },
    1: { text: '未确认', color: 'info' },
    2: { text: '异常', color: 'danger' }
};

//全部下 充值状态
export const ALL_TOP_UP_STATUS = [
    { value: 's1', text: '全部', queryData: { txStatus: [0, 10, 3, -1], txDepositStatus: [] } },
    { value: 's2', text: '充值成功', queryData: { txStatus: [0], txDepositStatus: [0] } },
    { value: 's3', text: '区块充值确认中', queryData: { txStatus: [3], txDepositStatus: [] } },
    { value: 's4', text: '区块充值成功,等待资金变更', queryData: { txStatus: [10], txDepositStatus: [] } },
    { value: 's5', text: '充值失败', queryData: { txStatus: [-1], txDepositStatus: [] } },
    { value: 's6', text: '充值成功异常', queryData: { txStatus: [0], txDepositStatus: [2] } }
];
//全部下 确认状态
export const ALL_SURE_STATUS = [
    { value: 's7', text: '全部', queryData: { txStatus: [0], txDepositStatus: [0, 1, 2] } },
    { value: 's8', text: '充值未确认', queryData: { txStatus: [0], txDepositStatus: [1] } },
    { value: 's9', text: '充值已确认成功', queryData: { txStatus: [0], txDepositStatus: [0] } },
    { value: 's10', text: '充值已确认异常', queryData: { txStatus: [0], txDepositStatus: [2] } },
];

export const ALL_STATUS = [
    { value: 's1', queryData: { txStatus: [0, 10, 3, -1], txDepositStatus: [] } },
    { value: 's2', queryData: { txStatus: [0], txDepositStatus: [0] } },
    { value: 's3', queryData: { txStatus: [3], txDepositStatus: [] } },
    { value: 's4', queryData: { txStatus: [10], txDepositStatus: [] } },
    { value: 's5', queryData: { txStatus: [-1], txDepositStatus: [] } },
    { value: 's6', queryData: { txStatus: [0], txDepositStatus: [2] } },
    { value: 's7', queryData: { txStatus: [0], txDepositStatus: [0, 1, 2] } },
    { value: 's8', queryData: { txStatus: [0], txDepositStatus: [1] } },
    { value: 's9', queryData: { txStatus: [0], txDepositStatus: [0] } },
    { value: 's10', queryData: { txStatus: [0], txDepositStatus: [2] } },
    { value: "s11", queryData: { txStatus: [3, 10], txDepositStatus: [] } },
    { value: "s12", queryData: { txStatus: [-1, 0], txDepositStatus: [2] } }
];

//等待中
export const AWAIT_TOP_UP_STATUS = {
    0: { text: '全部', queryData: { txStatus: [3, 10], txDepositStatus: [] } },
    1: { text: '区块充值确认中', queryData: { txStatus: [3], txDepositStatus: [] } },
    2: { text: '区块充值成功,等待资金变更', queryData: { txStatus: [10], txDepositStatus: [] } },
};
//风险异常
export const ERROR_TOP_UP_STATUS = {
    0: { text: '全部', queryData: { txStatus: -1, txDepositStatus: 2 } },
    1: { text: '充值失败', queryData: { txStatus: -1, txDepositStatus: [] } },
    2: { text: '充值成功异常', queryData: { txStatus: 0, txDepositStatus: 2 } }
};